import type { ReactNode } from 'react'
import { InfoIcon } from 'lucide-react'
import { useFormOptionalLabel, useFormReadOnly } from './shared'
import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { ButtonPrimitive } from '@/components/ui/button-primitive'

export function FieldLabelRow(props: {
  label: string
  htmlFor: string
  hasError: boolean
  optional?: boolean
  compactOptional?: boolean
  info?: ReactNode
  className?: string
}) {
  const optionalLabel = useFormOptionalLabel()
  const formReadOnly = useFormReadOnly()

  return (
    <div className={cn('flex items-center justify-between gap-6', props.className)}>
      <div className="flex h-5 items-center gap-1">
        {/* The label stays the normal text colour when the field is invalid: the message below carries the error. */}
        <Label data-slot="form-label" data-error={props.hasError} htmlFor={props.htmlFor}>
          {props.label}
          {props.optional === false && '*'}
        </Label>
        {props.info && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger
                render={
                  <ButtonPrimitive type="button" className="inline-flex" aria-label="More information">
                    <InfoIcon className="text-muted-foreground size-4" />
                  </ButtonPrimitive>
                }
              />
              <TooltipContent>{typeof props.info === 'string' ? <p>{props.info}</p> : props.info}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      {props.optional && !props.compactOptional && (
        <span className={cn('text-xs text-muted-foreground transition-opacity', formReadOnly && 'opacity-0')}>
          {optionalLabel}
        </span>
      )}
    </div>
  )
}
